import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Form } from "react-bootstrap";
import * as constants from "../api/constants";
import { Context } from "../App";
import SiteFooter from "../components/SiteFooter";
import "../adminConsoleTheme.css";

const Admin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { setContext } = useContext(Context);

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const payloadObj = { name: username, password };
    axios
      .post(constants.ADMIN_LOGIN_VALIDATE, payloadObj)
      .then((response) => {
        if (response.data.statuscode === 200) {
          // Backend now returns role on the login response. Default to ADMIN (booking-only) so a
          // legacy row without a role can still sign in safely.
          const role = String(response.data.role || "ADMIN").toUpperCase();
          const userName = response.data.userName || username;
          try {
            sessionStorage.setItem(
              "partyboss_admin_session",
              JSON.stringify({ role, userName, at: Date.now() })
            );
          } catch {
            /* ignore quota / privacy mode */
          }
          setContext((prev) => ({
            ...(prev && typeof prev === "object" ? prev : {}),
            isAdminLoggedIn: true,
            adminRole: role,
            adminUserName: userName,
          }));
          navigate("/admin/dashboard");
        } else {
          setError(response.data.message || "Login failed.");
        }
      })
      .catch(() => {
        setError("Username or password is incorrect. Please try again.");
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="admin-console-page admin-console-page--with-footer">
      <div className="admin-console-login-wrap">
        <div className="admin-console-login-card">
          <p className="mb-1 text-xs font-black uppercase tracking-[0.2em] text-[#ffd166]">
            Internal
          </p>
          <h1>Staff sign in</h1>
          <p className="subtitle">
            Bookings, payments, and add-ons — sign in to manage events.
          </p>
          {error ? <div className="admin-console-alert">{error}</div> : null}
          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-3">
              <Form.Label className="text-[#94a3b8] small fw-bold text-uppercase">
                Username
              </Form.Label>
              <Form.Control
                type="text"
                className="admin-console-login-input"
                autoComplete="username"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="text-[#94a3b8] small fw-bold text-uppercase">
                Password
              </Form.Label>
              <Form.Control
                type="password"
                className="admin-console-login-input"
                autoComplete="current-password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
            <button
              type="submit"
              className="btn-submit"
              disabled={submitting}
            >
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </Form>
        </div>
      </div>
      <div className="admin-console-site-footer-wrap">
        <SiteFooter />
      </div>
    </div>
  );
};

export default Admin;
